import { Suspense, useContext } from "react";

import { ComponentSpinner } from "@components/spinner";
import { Navigate } from "react-router-dom";
import { getPanelDefaultRoute } from "./routes";
// import { Navigate } from "react-router-dom";
// import { PanelDefaultRoute } from "@src/router/routes";
import { UserContext } from "@context/user";
import size from "lodash/size";
import themeConfig from "@configs/theme-config";

const PublicRoute = ({ children, route }) => {
  const {
    app: { name }
  } = themeConfig;
  const { userData, loading } = useContext(UserContext);

  if (route) {
    if (loading) {
      return <ComponentSpinner className="mt-5 pt-5" />;
    }
    const title = name;
    const restrictedRoute = route.meta && route.meta.restricted;
    if (size(userData?.user) && restrictedRoute) {
      return <Navigate to={getPanelDefaultRoute()} />;
    }
    document.title = route.meta.title || title;
  }

  return (
    <Suspense fallback={<ComponentSpinner className="mt-5 pt-5" />}>
      {children}
    </Suspense>
  );
};

export default PublicRoute;
